import { countFamiliesNeedingRerun } from "../../../../api/pipelineMoveBpa.service.js";
import { downloadCsv } from "../../../../utils/csvExport.js";
import { csvField, filenameStamp } from "../BatchUpdates/csvHelpers.js";
import type { MoveBpaRowResult } from "./useMoveBpaBatch.js";

export const RESULTS_HEADERS = [
  "line",
  "firm_ref",
  "firm_name",
  "publication_id",
  "target_practice_area_id",
  "target_practice_area_name",
  "target_table_id",
  "target_table_name",
  "expected_items",
  "status",
  "matched_roots",
  "matched_children",
  "already_in_place",
  "moved_approval_requests",
  "moved_testimonials",
  "moved_processing_items",
  "approval_failures",
  "families_needing_rerun",
  "pipeline_error",
  "warnings",
  "error",
  "note",
] as const;

export const WARNING_SEPARATOR = " | ";

function resultLine({ row, status, report, error }: MoveBpaRowResult): string {
  return [
    row.line,
    row.firmRef,
    row.firmName,
    row.publicationId,
    row.target.practiceAreaId,
    row.target.practiceAreaName,
    row.target.tableId,
    row.target.tableName,
    row.expectedItems,
    status,
    report?.matched.roots ?? null,
    report?.matched.children ?? null,
    report?.matched.alreadyInPlace ?? null,
    report?.moved.approvalRequests ?? null,
    report?.moved.testimonials ?? null,
    report?.moved.processingItems ?? null,
    report?.approvalSync.failed.length ?? null,
    report ? countFamiliesNeedingRerun(report) : null,
    report?.pipelineApply.error ?? null,
    report && report.warnings.length > 0 ? report.warnings.join(WARNING_SEPARATOR) : null,
    error,
    row.note,
  ]
    .map(csvField)
    .join(",");
}

export function buildResultsCsv(results: MoveBpaRowResult[]): string {
  return `${[RESULTS_HEADERS.join(","), ...results.map(resultLine)].join("\n")}\n`;
}

export function resultsFilename(dryRun: boolean, now: Date): string {
  return `move-bpa-${dryRun ? "dry-run" : "applied"}-${filenameStamp(now)}.csv`;
}

export function downloadResultsCsv(results: MoveBpaRowResult[], dryRun: boolean, at: Date): void {
  downloadCsv(buildResultsCsv(results), resultsFilename(dryRun, at));
}
